import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhoneTopPunchHoleCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"phone-top-punch-hole-center"} maskId="square-filled-radius-0-stroke-1-IconPhoneTopPunchHoleCenter"><path fillRule="evenodd" clipRule="evenodd" d="M17 3C19.2091 3 21 4.79086 21 7V21H3V7C3 4.79086 4.79086 3 7 3H17ZM12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPhoneTopPunchHoleCenter;
